import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  AdminApiPaths,
  TApiResponse,
  APIDataProvider,
  TApiPaginationResponse,
} from '../../../api';
import { IRole, IRoleDeleteVerificationData, IRolePermissions } from '.';

export type TAdminCreateRole = {
  name: string;
  type: string;
  permissions: IRolePermissions;
};

export type TAdminGetRoles = {
  limit: number;
  offset: number;
  sortKey?: string;
  sortValue?: number;
  searchText?: string;
};

export type TAdminUpdateRole = {
  id: string;
  name: string;
  type: string;
  permissions: IRolePermissions;
};

const apiDataProvider = new APIDataProvider();

const adminGetRolesModule = async ({
  limit,
  offset,
  sortKey,
  sortValue,
  searchText,
}: TAdminGetRoles) => {
  let path = `${AdminApiPaths.adminRoles}?limit=${limit}&offset=${offset}`;

  if (sortKey) {
    path += `&sortKey=${sortKey}`;
  }

  if (sortKey) {
    path += `&sortValue=${sortValue}`;
  }

  if (searchText) {
    path += `&searchText=${searchText}`;
  }

  const response = await apiDataProvider.get<
    TApiResponse<TApiPaginationResponse<IRole>>
  >(path);

  return response.data;
};

export const adminCreateRole = createAsyncThunk(
  '/admin/roles/create',
  async (data: TAdminCreateRole) => {
    const path = `${AdminApiPaths.adminRoles}`;

    const response = await apiDataProvider.post<TApiResponse<IRole>>(
      path,
      data
    );

    return response.data;
  }
);

export const adminUpdateRole = createAsyncThunk(
  '/admin/roles/update',
  async (data: TAdminUpdateRole) => {
    const path = `${AdminApiPaths.adminRoles}/${data.id}`;

    const response = await apiDataProvider.put<TApiResponse<IRole>>(path, data);

    return response.data;
  }
);

export const adminDeleteRole = createAsyncThunk(
  '/admin/settings/roles/delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminRoles}/${id}`;

    const response = await apiDataProvider.delete<TApiResponse<IRole>>(path);

    return response.data;
  }
);

export const adminVerifyRoleDelete = createAsyncThunk(
  '/admin/roles/verify-delete',
  async (id: string) => {
    const path = `${AdminApiPaths.adminRoles}/verify-delete/${id}`;

    const response = await apiDataProvider.get<
      TApiResponse<IRoleDeleteVerificationData>
    >(path);

    return response.data;
  }
);

export const adminGetRoles = createAsyncThunk(
  '/admin/roles/list',
  adminGetRolesModule
);

export const adminGetRolesForDropdown = createAsyncThunk(
  '/admin/roles/dropdown-list',
  adminGetRolesModule
);
